'use client'
import React, { useEffect } from 'react'
import { useCookieStore } from './cookie.store'

interface ICookieProviderProps {
  children: React.ReactNode
  token?: {
    accessToken?: string
    refreshToken?: string
  }
}

export const CookieProvider = (props: ICookieProviderProps) => {
  const { children, token } = props
  const setUpdateClient = useCookieStore((state) => state.setUpdateClient)

  useEffect(() => {
    if (token) {
      setUpdateClient(token.accessToken ?? '', token.refreshToken ?? '')
    }
  }, [setUpdateClient, token])

  return <>{children}</>
}
